var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"browse-main"},[_c('section',{staticClass:"page"},[_c('div',{staticClass:"search-main"},[_c('test-search')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }